/** themeSelector.tsx */
import React from "react";
/** Import the default theme first */
import { classes as project } from "../../../common/project.st.css";
/** import other themes */
import { classes as arts } from "../../../themes/arts.st.css";
import { classes as ielts } from "../../../themes/ielts.st.css";
/** Import theme selector styles */
import { classes as tsClasses } from "./themeselector.st.css";

const themes = {
  Default: [project.root],
  Arts: [project.root, arts.root],
  Ielts: [project.root, ielts.root]
};

export function changeTheme(name: keyof typeof themes) {
  if (themes[name]) {
    localStorage.componentLibCurrentTheme = name;
    document.documentElement.className = themes[name].join(" ");
  }
}

export function ThemeBar({ theme }: { theme: string }) {
  return (
    <div className={tsClasses.root}>
      <label className={tsClasses.label}>Theme: </label>
      <select
        defaultValue={theme}
        className={tsClasses.select}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          changeTheme(e.target.value as keyof typeof themes)
        }
      >
        {Object.keys(themes).map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
}
